import { Select } from './Select';

export type { TypeSelectProps } from './types';
export default Select;
